import * as React from 'react';
import {SCREENS, SECOND_PAGE, WP_CONTENT_PREFIX} from '../../constants';
import {Background} from '../../styled-components/Background';
import {PlotArea, PlotAreaMargin, PlotAreaWrapper} from '../../styled-components/PlotAreaComps';
import {StatusBar} from '../StatusBar';
import {Cloud} from '../../styled-components/Cloud';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';
import {analyticsEvent, sendGAEventToExtension} from '../../utils/analytics';
import {GestureGif, GroundInfo, InfoTitle} from "../GroundInfo";
import {Title} from "../../styled-components/Title";
import I18n from '../../utils/i18n';
import ReactHtmlParser from 'react-html-parser';
import BouncePrevention from '../../utils/BouncePrevention';
import {HelpOverlay} from "../HelpOverlay";
import {BounceOverlay} from "../BounceOverlay";

const Monster = styled.img`
    height: 25vh;
    margin-top: 10vh;
    transform: scaleX(-1);
`;

const MouseRunning = styled.img`
    height: 14vh;
    margin-top: 21vh;
    transform: scaleX(-1);
`;


export class SecondScreen extends React.Component {

    constructor() {
        super();
        this.OVERLAY_TYPES = {
            help: 'help',
            bounce: 'bounce'
        };
        this.state = {
            showHelpOverlay: false,
            showBounceOverlay: false,
            currentOverlay: null
        };
        this.onDragStart = this.onDragStart.bind(this);
        this.onVisible = this.onVisible.bind(this);
        this.closeHelpOverlay = this.closeHelpOverlay.bind(this);
        this.closeBounceOverlay = this.closeBounceOverlay.bind(this);
        this.renderOverlays = this.renderOverlays.bind(this);
    }

    onDragStart() {
        analyticsEvent('Onboarding',
            'Screen 2',
            'Link Clicked'
        );
        BouncePrevention.stopBouncePrevention();
    }

    onVisible(isVisible) {
        if(isVisible) {
            analyticsEvent('Onboarding',
                'Screen 1',
                'Scroll down'
            );
            analyticsEvent('Onboarding',
                'Screen 2',
                'Shown'
            );
            BouncePrevention.startObserving(() => {
                this.setState({
                    showHelpOverlay: true
                });
            });
            BouncePrevention.startBouncePrevention(() => {
                this.setState({
                    showBounceOverlay: true
                })
            });
            const currentScreen = 2;
            history.pushState({screen: currentScreen}, "", `?screen=${currentScreen}`);
            const heartFullToAnimate = document.querySelector('#full-2');
            heartFullToAnimate.classList.add("animation-heart-full");
            const heartHalfFullToAnimate = document.querySelector('#half-full-2');
            heartHalfFullToAnimate.classList.add("animation-heart-half-empty");
            sendGAEventToExtension('Onboarding', 'Screen 2', 'Shown');
        }
    }

    closeHelpOverlay() {
        this.setState({
            showHelpOverlay: false
        });
    }

    closeHelpOverlay() {
        this.setState({
            showHelpOverlay: false
        });
    }

    closeBounceOverlay() {
        this.setState({
            showBounceOverlay: false
        });
    }

    renderOverlays() {
        const {extensionInstalled} = this.props;
        const {currentOverlay} = this.state;
        if(!extensionInstalled) {
            return null;
        }
        if (currentOverlay === this.OVERLAY_TYPES.help) {
            return <HelpOverlay closeHelpOverlay={this.closeHelpOverlay} screen={SCREENS.second} />
        } else if (currentOverlay === this.OVERLAY_TYPES.bounce) {
            return <BounceOverlay screen={SCREENS.second} closeBounceOverlay={this.closeBounceOverlay} />
        } else {
            return null;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {showHelpOverlay, showBounceOverlay} = this.state;

        // hide help overlay
        if (showHelpOverlay && !nextState.showHelpOverlay) {
            this.setState({
                showBounceOverlay: false,
                currentOverlay: null
            });
        // show help overlay
        } else if (!showHelpOverlay && nextState.showHelpOverlay) {
            this.setState({
                currentOverlay: showBounceOverlay ? this.OVERLAY_TYPES.bounce : this.OVERLAY_TYPES.help
            });
        }
        // hide bounce overlay
        if (showBounceOverlay && !nextState.showBounceOverlay) {
            this.setState({
                showHelpOverlay: false,
                currentOverlay: null
            });
        // show bounce overlay
        } else if (!showBounceOverlay && nextState.showBounceOverlay) {
            this.setState({
                currentOverlay: showHelpOverlay ? this.OVERLAY_TYPES.help : this.OVERLAY_TYPES.bounce
            });
        }
        return true;
    }

    componentDidMount() {
        const newElement = document.createElement('img');
        newElement.src = `${WP_CONTENT_PREFIX}/images/link_arrow.gif`;
        newElement.classList.add('blue-link-arrow');
        document.querySelector(".blue-link").appendChild(newElement);
    }

    render() {
        const {toggleMusicPlaying, musicPlaying, extensionInstalled} = this.props;

        return (
            <Background>
                {this.renderOverlays()}
                <PlotAreaWrapper>
                    <StatusBar screen={SCREENS.second} toggleMusicPlaying={toggleMusicPlaying} musicPlaying={musicPlaying}/>
                    <Title>{I18n.translate('gestureInstructions2')}</Title>
                    <PlotArea>
                        <PlotAreaMargin margin='20vw' />
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='7vh' />
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='9vh' />
                        <Monster src={`${WP_CONTENT_PREFIX}/images/monster_run_animation.gif`} />
                        <MouseRunning src={`${WP_CONTENT_PREFIX}/images/mouse_run_animation.gif`} />
                        <PlotAreaMargin margin='5vw' />
                        <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='9vh' />
                    </PlotArea>
                </PlotAreaWrapper>
                <GroundInfo extensionInstalled={extensionInstalled} screen={SCREENS.second}>
                    <React.Fragment>
                        <VisibilitySensor onChange={this.onVisible}>
                        <InfoTitle marginTop="4vh" fontSize="2vh"> *** {I18n.translate('gameReference2')} ***</InfoTitle>
                        </VisibilitySensor>
                        <InfoTitle marginTop="3vh" onDragStart={this.onDragStart}>{ReactHtmlParser(`${I18n.translate('movementInstructions2Part1')} ${I18n.translate('movementInstructions2Part2')}${I18n.translate('movementInstructions2Part3')}`)}</InfoTitle>
                        <GestureGif src={`${WP_CONTENT_PREFIX}/images/right.gif`}></GestureGif>
                    </React.Fragment>
                </GroundInfo>
            </Background>
        );
    }
}
